import * as Dialog from "@radix-ui/react-dialog";
import { Link } from "react-router-dom";
import { MapPin, X } from "lucide-react";
import { categoryLabel, RegulatoryBadge } from "./CaseCard";
import { ExtLink } from "@/components/common/ExtLink";

const Part = ({ label, text }) => (
  <div className="border-t border-line pt-5">
    <h4 className="font-mono text-[12px] uppercase tracking-[0.18em] text-accent">{label}</h4>
    <p className="mt-2 text-[15px] leading-relaxed text-ink/90">{text}</p>
  </div>
);

// Full case study: The challenge / What SPC did / Result.
export const CaseModal = ({ c, onClose }) => (
  <Dialog.Root open={!!c} onOpenChange={(o) => !o && onClose()}>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-[60] bg-black/50 backdrop-blur-sm data-[state=open]:animate-in data-[state=open]:fade-in-0" />
      <Dialog.Content
        data-lenis-prevent
        className="fixed left-1/2 top-1/2 z-[61] max-h-[88vh] w-[calc(100%-2rem)] max-w-3xl -translate-x-1/2 -translate-y-1/2 overflow-y-auto border border-line bg-paper p-6 shadow-2xl focus:outline-none data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 sm:p-10"
        data-testid="case-modal"
      >
        {c && (
          <>
            <span className="rounded-none bg-accent-soft px-3 py-1 font-mono text-[12px] uppercase tracking-[0.14em] text-accent">{categoryLabel(c.category)}</span>
            <Dialog.Title className="mt-6 pr-8 font-display text-3xl font-semibold leading-[1.1] tracking-[-0.03em] text-ink sm:text-4xl">{c.title}</Dialog.Title>
            <p className="mt-4 flex items-center gap-2 text-[14px] font-medium text-ink">
              <MapPin className="h-4 w-4 text-accent" /> {c.markets}
            </p>
            <Dialog.Description className="mt-3 text-[15px] leading-relaxed text-muted">{c.summary}</Dialog.Description>
            {c.regulatory && (
              <div className="mt-4">
                <RegulatoryBadge />
              </div>
            )}
            <div className="mt-8 space-y-6">
              <Part label="The challenge" text={c.challenge} />
              <Part label="What SPC did" text={c.did} />
              <Part label="Result" text={c.result} />
              {c.link && (
                <ExtLink href={c.link.href} className="text-[15px]" testId="case-modal-link">
                  {c.link.label}
                </ExtLink>
              )}
              {c.product && (
                <Link to={c.product} className="ml-6 text-[15px] font-medium text-accent underline-offset-4 hover:underline" data-testid="case-modal-product-link">
                  View product page
                </Link>
              )}
            </div>
          </>
        )}
        <Dialog.Close
          className="absolute right-5 top-5 grid h-10 w-10 place-items-center rounded-none border border-line text-ink transition-colors hover:bg-surface"
          aria-label="Close case study"
          data-testid="case-modal-close"
        >
          <X className="h-4 w-4" />
        </Dialog.Close>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
